import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import {makeStyles, MenuItem, TextField} from "@material-ui/core";
import MaterialSelect from "@material-ui/core/Select/Select";
import ColorPicker from "../../../../../../../../Utils/ColorPicker";
import TypeEntity from "../../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import {valueHandlerDefault} from "../../../../../../../../Utils/Form/FormDynamic/Utils/valueHandler";
import {convertToStringShortcut} from "../../Panels/Actions/ActionForm/ShortcutInput";

const useStyles = makeStyles((theme) => ({
    textField: {
        marginLeft: 0,
        marginRight: theme.spacing(),
    },
}));

const Fields = ({field, path, onChange, values}) => {
    return (
        <>
            {(() => {
                switch (field.type) {
                    case 'string': {
                        return <TypeString values={values} field={field} onChange={onChange} path={path}/>
                    }
                    case 'number': {
                        return <TypeNumber values={values} field={field} onChange={onChange} path={path}/>
                    }
                    case 'select': {
                        return <TypeSelect values={values} field={field} onChange={onChange} path={path}/>
                    }
                    case 'suggestions': {
                        return <TypeSuggestions values={values} field={field} onChange={onChange} path={path}/>
                    }
                    case 'stringArray': {
                        return <TypeStringArray values={values} field={field} onChange={onChange} path={path}/>
                    }
                    case 'colorPicker': {
                        return <TypeColorPicker values={values} field={field} onChange={onChange} path={path}/>
                    }
                    case 'multiValue': {
                        return <TypeMultiValue values={values} field={field} onChange={onChange} path={path}/>
                    }
                    default: {
                        return <TypeString values={values} field={field} onChange={onChange} path={path}/>
                    }
                }
            })()}
        </>
    )
};

Fields.propTypes = {
    field: PropTypes.object.isRequired,
    path: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.any.isRequired
};

export default Fields;


const TypeString = ({field, path, values, onChange}) => {
    const classes = useStyles();
    let simpleValue = '';
    let pathToValue = path ? path : field.name;
    simpleValue = valueHandlerDefault(values, pathToValue, simpleValue);
    return (
        <TextField
            id={path}
            className={`${classes.textField} form-table`}
            fullWidth={true}
            disabled={field.disabled}
            variant="standard"
            onChange={(event) => onChange(event.target.value, path)}
            margin='none'
            name={field.name}
            value={simpleValue || ''}
            InputProps={{
                disableUnderline: true,
                style: {padding: 0}
            }}
        />
    )
};

const TypeNumber = ({field, values, onChange}) => {
    const classes = useStyles();
    return (
        <TextField
            id={`${field.name}Props`}
            className={classNames(`${classes.textField} form-table`, {
                [`${classes.textField} form-table-disabled`]: field.disabled
            })}
            fullWidth={true}
            variant="outlined"
            disabled={field.disabled}
            onChange={onChange}
            margin='none'
            type='number'

            InputProps={{
                min: 0,
                disableUnderline: true,
                style: {padding: 0}
            }}
            name={field.name}
            value={values[field.name] || ''}
        />
    )
};

const TypeSelect = ({field, path, values, onChange}) => {
    const classes = useStyles();
    let simpleValue = '';
    let pathToValue = path ? path : field.name;
    simpleValue = valueHandlerDefault(values, pathToValue, simpleValue);
    const objValue = valueHandlerDefault(values, pathToValue.split('.').slice(0, 1).join('.'), '')

    function generateLabel(value, label) {
        if (objValue.event === 'onKeydown' && objValue.shortcut && value === 'onKeydown') {
            return label + ` (${convertToStringShortcut(objValue.shortcut)})`
        }

        return label
    }

    return (
        <MaterialSelect
            disableUnderline
            id={`${field.name}Props`}
            className={`${classes.textField} form-screenDesigner`}
            fullWidth={true}
            onChange={(event) => onChange(event.target.value, path)}
            disabled={field.disabled}
            name={field.name}
            value={simpleValue === false ? 'false' : simpleValue || ''}
            inputProps={{
                className: 'form-dynamic-bool',
            }}
        >
            {(field.menu || []).map((item, index) => {
                return (
                    <MenuItem style={{paddingTop: 2, paddingBottom: 2}} key={index} value={item.value}>
                        {generateLabel(item.value, item.label)}
                    </MenuItem>
                )
            })}
        </MaterialSelect>
    )
};

const TypeSuggestions = ({field, path, values, onChange}) => {
    return (
        <TypeEntity
            showLabel={false}
            fieldStyles={{fullWidth: true, withoutStyles: true}}
            setValue={onChange}
            values={values}
            field={{
                name: field.name,
                path,
                entity: field.source
            }}
        />
    )
};

const TypeStringArray = () => {
    // let pathToValue = path ? path : element.name;
    // const {onChangeStringArray, values} = this.props;
    // return (<TypeStringArray onChange={onChangeStringArray} values={values} path={pathToValue} element={element}/>)
};

const TypeColorPicker = ({field, values, onChange}) => {
    return (
        <div>
            <ColorPicker onChange={onChange} values={values} name={field.name}
                         value={values[field.name]}/>
        </div>
    )
};

const TypeMultiValue = ({field, values, onChange}) => {
    const classes = useStyles();
    return (
        <div
            style={{display: 'flex', flexDirection: 'row'}}>
            {field.fields.map((field, index) => {
                return (
                    <TextField
                        key={index}
                        type='number'
                        style={{marginTop: 5}}
                        onChange={onChange}
                        value={values[`${field.name}${field.value}`] || ''}
                        label={field.label}
                        name={`${field.name}${field.value}`}
                        className={`${classes.textField} form-table-multiValue`}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            style: {padding: 0}
                        }}
                        variant='outlined'
                    />
                )
            })}
        </div>
    )
};
